import React, { useState } from "react"

import { useDropzone } from "react-dropzone"
import UploadImg from "images/inline/uploadimg.svg"
import UploadIcon from "images/inline/ugc/upload.svg"
import WebcamCapture from "./Webcam"
import LegacyRetinaImage from 'components/LegacyRetinaImage'
const UploadCTA = ({ onGetProperFile, frameSelected }) => {
  const [dropzoneError, setDropzoneError] = useState("")

  const { acceptedFiles, fileRejections, isDragActive, isDragAccept, isDragReject, onDrop, getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: "image/*",
    multiple: false,
    minSize: 1024,
    maxSize: 3072000,
    onDrop: acceptedFiles => {
      handleDrop(acceptedFiles)
    },
  })

  const handleProcessingFileData = inputFile => {
    const temporaryFileReader = new FileReader()

    return new Promise((resolve, reject) => {
      temporaryFileReader.onerror = () => {
        temporaryFileReader.abort()
        reject(new DOMException("Problem parsing input file."))
      }
      temporaryFileReader.onload = () => {
        resolve(temporaryFileReader.result)
      }
      temporaryFileReader.readAsDataURL(inputFile)
    })
  }

  const handleDrop = async acceptedFiles => {
    try {
      let contents = await Promise.all(acceptedFiles.map(file => handleProcessingFileData(file)))
      if (onGetProperFile && contents.length > 0) {
        onGetProperFile(contents[0])
      }
    } catch (e) {
      console.log(e)
    }
  }

  const fileRejectionItems = fileRejections.map(({ file, errors, i }) => {
    let msg = "Error with file uploaded"
    console.log(errors)
    try {
      msg = errors
        .map(function(err) {
          let errmessage = err.message
          if (err.code.indexOf("invalid-type") > -1) {
            errmessage = "File must be an image"
          } else if (err.message.indexOf("larger") > -1) {
            errmessage = "File must be smaller than 3mb."
          }
          return errmessage
        })
        .join(" ")
    } catch (e) {
      console.log(e)
    }
    return <div key={`file-error-${i}`}>{msg}</div>
  })

  return (
    <div className={`dropzone-outer-limit`}>
      <span className={`dropzone-error-dialogue`}> {fileRejectionItems}</span>
      <div {...getRootProps({ className: `dropzone ${isDragAccept ? "dragged-file-accepted" : ""} ${isDragReject ? "dragged-file-rejected" : ""} ${isDragActive ? "file-drag-active" : ""} ${dropzoneError !== "" ? `error-uploading` : ""} ${frameSelected && frameSelected.image ? "has-preview-frame" : ""}` })}>
        <input {...getInputProps()} />
       
        {frameSelected && frameSelected.image && <LegacyRetinaImage image={frameSelected.image} className={`upload-frame-preview`} />}
        <span className={`image-dropzone-bg`}>
          <UploadImg />
        </span>
       
        <button className="btn upload-button dropzone-button">
          <UploadIcon /><span>Upload a photo</span>
        </button>
        
      </div>
      <WebcamCapture onPhotoSave={onGetProperFile} />
    </div>
  )
}

export default UploadCTA
